var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C1F7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25C11.0294 25 7 20.9706 7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25ZM19.1036 14.0804C19.4305 13.7534 19.4305 13.2234 19.1036 12.8964C18.7767 12.5694 18.2467 12.5694 17.9196 12.8964L15.9998 14.816L14.0803 12.8967C13.7534 12.5697 13.2233 12.5698 12.8964 12.8967C12.5694 13.2237 12.5694 13.7538 12.8964 14.0807L14.8158 16L12.8964 17.9193C12.5694 18.2462 12.5694 18.7764 12.8964 19.1033C13.2233 19.4302 13.7534 19.4302 14.0803 19.1033L15.9998 17.184L17.9196 19.1036C18.2467 19.4305 18.7767 19.4305 19.1036 19.1036C19.4305 18.7766 19.4305 18.2466 19.1036 17.9196L17.1839 16L19.1036 14.0804Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryReject);
export default __webpack_public_path__ + "static/media/history-reject.052e8120f6edd0fcf3b20d251fa120ce.svg";
export { ForwardRef as ReactComponent };